/**
 * Company holidays — org-configured dates that block scheduling org-wide.
 * Stored as settings.company_holidays: [{ date: 'YYYY-MM-DD', name: 'Thanksgiving' }].
 */

export interface CompanyHoliday {
  date: string; // YYYY-MM-DD
  name: string;
}

type OrgSettingsWithHolidays = { company_holidays?: CompanyHoliday[] } | undefined | null;

/** The holiday falling on the given YYYY-MM-DD date, or null. */
export function getHolidayForDate(
  orgSettings: OrgSettingsWithHolidays,
  date: string | undefined | null
): CompanyHoliday | null {
  if (!date || !Array.isArray(orgSettings?.company_holidays)) return null;
  return orgSettings.company_holidays.find(h => h?.date === date) || null;
}

/** Set of holiday date strings (YYYY-MM-DD) for fast lookups. */
export function buildHolidaySet(orgSettings: OrgSettingsWithHolidays): Set<string> {
  const holidays = Array.isArray(orgSettings?.company_holidays) ? orgSettings.company_holidays : [];
  return new Set(holidays.map(h => h?.date).filter(Boolean) as string[]);
}
